import update from 'immutability-helper'
import {
  SIGN_IN,
  SIGN_UP,
  SIGN_OUT
} from 'actions/auth'
import { START_ROUNDUPS, STOP_ROUNDUPS, START_TITHING, STOP_TITHING } from 'actions/campaigns'
import { CREATE_FUNDRAISER_ACCOUNT } from 'actions/fundraiserAccounts'
import { INTEGRATE_SUPPORTER_ACCOUNTS } from 'actions/supporters'
import { RECONNECT_TRACKED_ACCOUNT_PROVIDER } from 'actions/trackedAccountProviders'
import { VERIFY_USER_EMAIL, UPDATE_USER, REFRESH_USER_DATA } from 'actions/users'
import { CONFIRM_TITHE, CANCEL_TITHE } from 'actions/tithes'

const setUser = (state, action) => resultingUser(action)

const updateUser = (state, action) => ({ ...state, ...resultingUser(action) })

const clearUser = state => null
  
const addRoundedUpJar = (state, action) => (
  update(state, { roundedUpJars: { $push: [resultingId(action)] } })
)

const removeRoundedUpJar = (state, action) => {
  const indexForRemoval = entityIndex(action, state.roundedUpJars)
  return update(state, { roundedUpJars: { $splice: [[indexForRemoval, 1]] } })
}

const addTithedJar = (state, action) => (
  update(state, { tithedJars: { $push: [resultingId(action)] } })
)

const removeTithedJar = (state, action) => {
  const indexForRemoval = entityIndex(action, state.tithedJars)
  return update(state, { tithedJars: { $splice: [[indexForRemoval, 1]] } })
}

function entityIndex(action, entities) {
  const entityId = resultingId(action)
  return entities.findIndex((id) => id === entityId)
}

const integrateSupporterAccountsFulfilled = (state, action) => {
  const { trackedAccountProviders, trackedAccounts, withdrawalAccount } = resultingUser(action)

  return { ...state, trackedAccountProviders, trackedAccounts, withdrawalAccount }
}

const reconnectTrackedAccountProvider = (
  state, { payload: { data: { result: trackedAccountProviderId, entities: { trackedAccountProviders } } } }
) => {
  const reconnectedProvider = trackedAccountProviders[trackedAccountProviderId]
  const { archivedTrackedAccounts: archivedTrackedAccountIds, trackedAccounts: reconnectedTrackedAccountIds } = reconnectedProvider
  const newTrackedAccountIds = [...state.trackedAccounts]
  archivedTrackedAccountIds.forEach((id) => {
    const indexToSplice = newTrackedAccountIds.indexOf(id)
    if (indexToSplice !== -1) {
      newTrackedAccountIds.splice(newTrackedAccountIds.indexOf(id), 1)
    }
  })

  reconnectedTrackedAccountIds.forEach((id) => {
    if(newTrackedAccountIds.indexOf(id) === -1) {
      newTrackedAccountIds.push(id)
    }
  })

  return update(state, { trackedAccounts: { $set: newTrackedAccountIds } })
}

const verifyUserEmailFulfilled = state => (
  { ...state, emailConfirmed: true }
)

const setFundraiserAccount = (state, action) => (
  { ...state, fundraiserAccount: resultingId(action) }
)

const cancelTithe = (state, action) => {
  const indexForRemoval = entityIndex(action, state.unprocessedTithes)
  return update(state, { unprocessedTithes: { $splice: [[indexForRemoval, 1]] } })
}

const confirmTithe = (state, action) => {
  const confirmedTitheIndex = entityIndex(action, state.unprocessedTithes)
  const { entities, result: titheId } = action.payload.data
  const { tithes, donations } = entities

  const titheAmount = +tithes[titheId].amount

  // NOTE: this is why we need graphQL
  const newHistoricDonationSums = {}
  Object.entries(state.historicDonationSums).forEach((entry) => {
    const [key, value] = entry
    newHistoricDonationSums[key] = (titheAmount + +value).toFixed(2)
  })

  const newHistoricTitheCounts = {}
  Object.entries(state.historicTitheCounts).forEach((entry) => {
    const [key, value] = entry
    newHistoricTitheCounts[key] = value + 1
  })

  const newDonationSumsByJar = { ...state.donationSumsByJar }
  Object.values(donations).forEach(({ amount, campaignId }) => {
    const oldAmount = newDonationSumsByJar[campaignId]
    if(oldAmount) {
      newDonationSumsByJar[campaignId] = (+amount + +oldAmount).toFixed(2)
    } else {
      newDonationSumsByJar[campaignId] = amount
    }
  })
  return update(state, {
    historicDonationSums: { $set: newHistoricDonationSums },
    historicTitheCounts:  { $set: newHistoricTitheCounts},
    unprocessedTitheCount:  { $set: state.unprocessedTitheCount - 1},
    donationSumsByJar:  { $set: newDonationSumsByJar},
    unprocessedTithes: { $splice: [[confirmedTitheIndex, 1]] },
    mostRecentProcessedTithes: { $unshift: [titheId] }
  })
}

const resultingId = action => action.payload.data.result

const resultingUser = action => action.payload.data.entities.users[resultingId(action)]

const handlers = {
  [`${SIGN_IN}_FULFILLED`]: setUser,
  [`${SIGN_UP}_FULFILLED`]: setUser,
  [`${REFRESH_USER_DATA}_FULFILLED`]: setUser,
  [`${SIGN_OUT}_FULFILLED`]: clearUser,
  [`${START_ROUNDUPS}_FULFILLED`]: addRoundedUpJar,
  [`${STOP_ROUNDUPS}_FULFILLED`]: removeRoundedUpJar,
  [`${START_TITHING}_FULFILLED`]: addTithedJar,
  [`${STOP_TITHING}_FULFILLED`]: removeTithedJar,
  [`${CONFIRM_TITHE}_FULFILLED`]: confirmTithe,
  [`${CANCEL_TITHE}_FULFILLED`]: cancelTithe,
  [`${INTEGRATE_SUPPORTER_ACCOUNTS}_FULFILLED`]: integrateSupporterAccountsFulfilled,
  [`${VERIFY_USER_EMAIL}_FULFILLED`]: verifyUserEmailFulfilled,
  [`${UPDATE_USER}_FULFILLED`]: updateUser,
  [`${CREATE_FUNDRAISER_ACCOUNT}_FULFILLED`]: setFundraiserAccount,
  [`${RECONNECT_TRACKED_ACCOUNT_PROVIDER}_FULFILLED`]: reconnectTrackedAccountProvider
}

export default function userReducer(state = null, action) {
  const handler = handlers[action.type]
  return handler ? handler(state, action) : state
}
